module.exports = "//__CDN_HOST__/2.0.8/img/total-car-cost-calculator-banner.5790c797.png";